import { useMemo } from 'react';
import classNames from 'classnames';
import { equals } from 'ramda';

const defaultClassNames = 'items-center font-bold text-2xl tracking-normal';

const Title = ({ title = 'primary', variant, toUpper = false, onClick = null, className = '' }) => {
  const isPrimary = useMemo(() => equals(variant, 'primary'), [variant]);
  const isSecondary = useMemo(() => equals(variant, 'secondary'), [variant]);
  const isTertiary = useMemo(() => equals(variant, 'tertiary'), [variant]);
  const isTertiaryMobile = useMemo(() => equals(variant, 'tertiary-mobile'), [variant]);

  const classes = useMemo(
    () =>
      classNames(defaultClassNames, {
        'text-2xl': isPrimary || isSecondary,
        'text-[28px]': isTertiary,
        'text-[22px]': isTertiaryMobile,
        'text-[#9FA4C7] cursor-pointer decoration-1 underline-offset-4 hover:underline hover:text-primary ':
          onClick,
        uppercase: toUpper
      }),
    [toUpper, variant]
  );

  return (
    <p className={`${classes} ${className}`} onClick={onClick}>
      {title}
    </p>
  );
};

export default Title;
